import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})

export class CompaniesService {
  get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthServiceService) { }

  // ============================================
  // EXISTING - company listing (BehaviorSubject)
  // ============================================
  private companyData: { companyes: object[] } = { companyes: [] };
  private _companyData = new BehaviorSubject<object[]>([]);

  companynameAdd(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/add-company/`, form)
      .pipe(
        map((data: any) => {
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

  companySearch(page: any = 1, searchVal?: string): void {
    const params: string[] = [`page=${page}`];

    if (searchVal) {
      params.push(`company_name=${encodeURIComponent(searchVal)}`);
    }

    const queryString = params.join('&');

    this.http
      .get<any>(`${this._liveApiUrl}/company/company-listing/?${queryString}`)
      .pipe(
        catchError(this.authService.handleError)
      )
      .subscribe({
        next: (data: any) => {
          if (data?.errorMessage === 'Invalid page number' && page > 1) {
            this.companySearch(page - 1, searchVal);
            return;
          }

          this.companyData.companyes = data;
          this._companyData.next({ ...this.companyData }.companyes);
        },
        error: (error) => {
          this.authService.dataError(error);
        }
      });
  }

  getCompanyess(): Observable<any[]> {
    return this._companyData.asObservable();
  }

  companySearchObservable(page: any = 1, searchVal?: string, pageSize?: number): Observable<any> {
    const params: string[] = [`page=${page}`];
    if (pageSize) {
      params.push(`page_size=${pageSize}`);
    }
    if (searchVal) {
      params.push(`company_name=${encodeURIComponent(searchVal)}`);
    }
    return this.http.get<any>(`${this._liveApiUrl}/company/company-listing/?${params.join('&')}`).pipe(
      catchError(this.authService.handleError)
    );
  }

  companyDelete(id: any) {
    return this.http.delete<any>(
      `${this._liveApiUrl}/company/delete-company/${id}`
    );
  }

  mergeCompany(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/merge-company/`, form)
      .pipe(
        map((data: any) => {
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

  editCompany(id: Number, form: any): Observable<any> {
    return this.http
      .put<any>(`${this._liveApiUrl}/company/update-company/${id}`, form)
      .pipe(
        map((data: any) => {
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

  // ============================================
  // EXISTING - view company listing (BehaviorSubject)
  // ============================================
  private viewcompanyData: { viewcompanyes: object[] } = { viewcompanyes: [] };
  private _viewcompanyData = new BehaviorSubject<object[]>([]);

  viewcompanySearch(page: any, compName?: string, showDuplicates: boolean = true) {
    let queryParams = `page=${page}`;

    if (compName) {
      queryParams += `&company_name=${encodeURIComponent(compName)}`;
    }
    queryParams += `&show_duplicates=${showDuplicates}`;

    this.http
      .get<any>(`${this._liveApiUrl}/company/company-listing/?${queryParams}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {

          this.viewcompanyData.viewcompanyes = data;
          this._viewcompanyData.next(Object.assign({}, this.viewcompanyData).viewcompanyes);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }

  viewgetCompanyess(): Observable<any[]> {
    return this._viewcompanyData.asObservable();
  }

  // ============================================
  // NEW - all-company-listing with company_type filter
  // ============================================
  allCompanySearch(page?: number, searchVal?: string, companyType?: string, showDuplicates: boolean = false, pageSize?: number): Observable<any> {
    const params: string[] = [];
    if (page) {
      params.push(`page=${page}`);
    }
    if (pageSize) {
      params.push(`page_size=${pageSize}`);
    }

    if (searchVal) {
      params.push(`company_name=${encodeURIComponent(searchVal)}`);
    }
    if (companyType) {
      params.push(`company_type=${encodeURIComponent(companyType)}`);
    }
    params.push(`show_duplicates=${showDuplicates}`);

    const queryString = params.join('&');

    return this.http
      .get<any>(`${this._liveApiUrl}/company/all-company-listing/?${queryString}`)
      .pipe(catchError(this.authService.handleError));
  }

}